import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import CopyCheckbox from './CopyCheckbox';

const GridContainer = styled('div')`
  display: flex;
  gap: 16px;
  padding: 16px;
  overflow-x: auto;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.surfaceSecondary};
`;

const WeekColumn = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;
`;

const WeekLabel = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
`;

const CopyProgramDayGrid = ({
  weeks, selectedKeys, onToggleDay, idPrefix,
}) => {
  const handleChange = (e) => {
    const { week, day } = e.target.dataset;
    onToggleDay(Number(week), Number(day));
  };

  return (
    <GridContainer>
      {weeks.map((week) => (
        <WeekColumn key={week.weekNumber}>
          <WeekLabel>{`Week ${week.weekNumber}`}</WeekLabel>
          {week.days.map((day) => (
            <CopyCheckbox
              checked={selectedKeys.has(`${week.weekNumber}-${day.dayNumber}`)}
              id={`${idPrefix}-${week.weekNumber}-${day.dayNumber}`}
              inputProps={{ 'data-week': week.weekNumber, 'data-day': day.dayNumber }}
              key={`${week.weekNumber}-${day.dayNumber}`}
              label={`Day ${day.dayInWeek}`}
              onChange={handleChange}
            />
          ))}
        </WeekColumn>
      ))}
    </GridContainer>
  );
};

CopyProgramDayGrid.propTypes = {
  weeks: PropTypes.arrayOf(PropTypes.shape({
    weekNumber: PropTypes.number,
    days: PropTypes.arrayOf(PropTypes.shape({
      dayNumber: PropTypes.number,
      dayInWeek: PropTypes.number,
    })),
  })).isRequired,
  selectedKeys: PropTypes.instanceOf(Set).isRequired,
  onToggleDay: PropTypes.func.isRequired,
  idPrefix: PropTypes.string.isRequired,
};

export default CopyProgramDayGrid;
